import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollRestoration = () => {
  const location = useLocation();

  // Use useLayoutEffect to run before any visual updates
  useLayoutEffect(() => {
    const savedScrollPosition = sessionStorage.getItem('scrollPosition');
    
    if (savedScrollPosition && location.pathname === '/') {
      const scrollY = parseInt(savedScrollPosition, 10);
      
      // Restore scroll position immediately before browser paints
      document.documentElement.scrollTop = scrollY;
      document.body.scrollTop = scrollY; // For older browsers
      
      // Clean up immediately
      sessionStorage.removeItem('scrollPosition');
    }
  }, [location]);

  const saveScrollPosition = () => {
    const scrollY = window.scrollY;
    sessionStorage.setItem('scrollPosition', scrollY.toString());
  };

  return { saveScrollPosition };
};